// Table関連
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, } from '@mui/material';

function LinkCollection() {
  return (
    <>
      <div>LinkCollection</div>
      <div style={{ margin: "5px" }}>
        {/* データ一覧 */}
        <TableContainer component={Paper} sx={{ width: '100%' }}>
          <Table stickyHeader sx={{ width: '100%' }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: '10%' }}>created_at</TableCell>
                <TableCell sx={{ width: '40%' }}>message</TableCell>
                <TableCell sx={{ width: '10%' }}>リンク</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell><a href="https://developers-toolkit-jp.com/tools/url-encoder" target='_blank'>URLエンコーダー/デコーダー</a></TableCell>
              </TableRow>
              <TableRow>
                <TableCell><a href="https://qiita.com/sa9ra4ma/items/358c936bc481a4c54866" target='_blank'>正しいURLエンコードの方法</a></TableCell>
              </TableRow>
              <TableRow>
                <TableCell><a href="https://www.jwt.io/" target='_blank'>JWTデバッガ</a></TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>

    </>
  )
}
export default LinkCollection